<template>
  <div class="home-page">
    <section class="home-panel">
      <div>
        <span class="home-eyebrow">Painel administrativo</span>
        <h1>Olá, {{ User.nome }}</h1>
        <p>Use o menu lateral para configurar e editar os conteúdos institucionais.</p>
      </div>
      <img src="/images/banner-img.png" alt="">
    </section>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data: () => ({
    User: {
      nome: ''
    }
  }),
  created() {
    const valorArmazenado = sessionStorage.getItem('_userav');
    if (valorArmazenado) {
      this.User = JSON.parse(valorArmazenado);
    }
  },
}
</script>

<style scoped>
.home-page {
  background: #f3f5f7;
  min-height: calc(100vh - 80px);
  padding: 28px 32px;
}

.home-panel {
  align-items: center;
  background: #fff;
  border: 1px solid #dbe2ea;
  border-radius: 8px;
  display: flex;
  gap: 24px;
  justify-content: space-between;
  min-height: 220px;
  padding: 28px;
}

.home-eyebrow {
  color: #64748b;
  display: block;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  margin-bottom: 8px;
  text-transform: uppercase;
}

.home-panel h1 {
  color: #172331;
  font-size: 30px;
  font-weight: 700;
  line-height: 1.2;
  margin: 0 0 8px;
}

.home-panel p {
  color: #475569;
  font-size: 15px;
  margin: 0;
}

.home-panel img {
  max-width: 260px;
  width: 32%;
}

@media (max-width: 720px) {
  .home-page {
    padding: 18px 14px;
  }

  .home-panel {
    align-items: flex-start;
    flex-direction: column;
  }

  .home-panel img {
    max-width: 180px;
    width: 70%;
  }
}
</style>
